import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { PendingActionsCounts } from './types';

export const generalLoaders = getLoaders({
  pendingActionsCounts: {
    load: async (): Promise<PendingActionsCounts> => {
      return executeApiCall({
        path: '/pending-actions/async-count',
        method: 'get',
      });
    },
  },
});
